import i18n from '@/i18n';
import type { OpenNotificationParams } from '@/services/notification/models/notification';
import { notificationService } from '@/services/notification/notification-service';
import { findNotification } from '@/utils/errors/notification-registry';
import { httpToClientError } from 'cesg-shared';
import type { Wretch } from 'wretch';
import type { QueryStringAddon } from 'wretch/addons';
import type { WretchError } from 'wretch/resolver';

type WretchRequest = Wretch<QueryStringAddon, unknown, undefined> &
  QueryStringAddon;

function genericNotification(error: WretchError): OpenNotificationParams {
  const { t } = i18n.global;
  return {
    text: t('notifications.requestFailed', {
      message: error.message || t('notifications.unknownError'),
    }),
    type: 'warning',
  };
}

export function handleHttpErrors(error: WretchError, request: WretchRequest) {
  // Keep the URL out of the user-facing toast, but log it for d
  // ebugging.
  console.error('Request failed', request._url, error);

  const clientError = httpToClientError(error.json);

  if (clientError) {
    notificationService.open(
      findNotification(clientError) ?? genericNotification(error),
    );
    throw clientError;
  }

  notificationService.open(genericNotification(error));
  throw error;
}
